import React, { createContext, useContext, useState, useEffect } from "react";
import { getDomainInfo } from "../utils/utils";

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
    const { hostname, isPredefinedDomain, uid } = getDomainInfo();
    const [storeID, setStoreID] = useState(null);

    useEffect(() => {
        setStoreID(isPredefinedDomain ? uid : hostname);
    }, [hostname, isPredefinedDomain, uid]);

    return (
        <StoreContext.Provider value={{ storeID, setStoreID }}>
            {children}
        </StoreContext.Provider>
    );
};

export const useStore = () => useContext(StoreContext);
